  <a class="flyout-icon" (igA11yLink)="myOnClick($event)" [class.menu-open]="isMenuOpen" [attr.title]="ariaLabel">
    <div *ngIf="showBadge && !showBadgeAsDot" [ngClass]="'badge ' + badgeColor"
      [class.visible]="badgeCount > 0" [class.was-visible]="badgeWasVisible">{{ badgeCount }}</div>
    <div *ngIf="showBadge && showBadgeAsDot" [ngClass]="'badge dot-badge ' + badgeColor"
      [class.visible]="badgeCount > 0" [class.was-visible]="badgeWasVisible"><i class="fas fa-circle"></i>
    </div>

    <i [ngClass]="iconCls"></i>
  </a>
